import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetSingleTutorDocAdmin = (id: string) => {
  const token = localStorage.getItem("W2ST_ADMIN_TOKEN");

  return useQuery({
    queryKey: ["useGetSingleTutorDocAdmin", id],
    queryFn: async () => {
      if (!token) throw new Error("Authorization token is missing");

      const response = await axiosInstance.get(`admins/tutor-docs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    },
    onSuccess: (data) => {
      console.log("Success Getting Tutor =>", data);
    },
    onError: (error: unknown) => {
      console.error("Failed Getting Tutor =>", error);
    },
    enabled: !!token && !!id,
  });
};
